import { Layout } from '../../Layout';
import ProjectContainer from './ProjectContainer';

const EstimationDetailProjectTab = () => {
  return (
    <Layout>
      <ProjectContainer />
    </Layout>
  );
};

export default EstimationDetailProjectTab;
